import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getAllPartenaires } from "../../services/partenairesServices";
import useScrollToTop from "./../../hooks/useScollToTop";

const PartenaireDetail = () => {
  useScrollToTop();
const navigate = useNavigate();
  const { nom } = useParams();
  const [partenaire, setPartenaire] = useState(null);
  const [mapUrl, setMapUrl] = useState("");

  useEffect(() => {
    const fetch = async () => {
      const data = await getAllPartenaires();
      const match = data.find((p) => p.nom === decodeURIComponent(nom));
      setPartenaire(match);
    };
    fetch();
  }, [nom]);

  useEffect(() => {
    if (partenaire?.adresse) {
      const encoded = encodeURIComponent(partenaire.adresse);
      setMapUrl(`https://www.google.com/maps?q=${encoded}&output=embed`);
    }
  }, [partenaire]);

  if (!partenaire) return <p className="text-center mt-20">Chargement...</p>;

  return (
    <div className="flex flex-col w-full max-w-[1280px] mx-auto p-6 px-10 mt-[120px] bg-backgroundMain dark:bg-backgroundMainDark dark:text-white">
      <div className="mb-4">
        <button
          onClick={() => navigate("/partenaires")}
          className="text-sm px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark transition"
        >
          ← Retour à la liste des partenaires
        </button>
      </div>
      {/* Titre + logo */}
      <div className="flex flex-col md:flex-row items-center md:items-start mb-8 gap-6">
        <img
          src={partenaire.photo_url}
          alt={partenaire.nom}
          className="w-32 h-32 object-contain"
        />
        <h1 className="text-3xl font-bold text-center md:text-left">
          {partenaire.nom}
        </h1>
      </div>

      {/* Bloc 1 : photo2 à gauche, description2 à droite */}
      {(partenaire.photo2_url || partenaire.description2) && (
        <div className="flex flex-col md:flex-row gap-6 mb-8 items-center">
          {partenaire.photo2_url && (
            <img
              src={partenaire.photo2_url}
              alt="photo 2"
              className="w-full md:w-1/2 rounded shadow"
            />
          )}
          {partenaire.description2 && (
            <div
              className="w-full md:w-1/2 prose dark:prose-invert max-w-none text-justify"
              dangerouslySetInnerHTML={{ __html: partenaire.description2 }}
            />
          )}
        </div>
      )}

      {/* Bloc 2 : description3 à gauche, photo3 à droite */}
      {(partenaire.description3 || partenaire.photo3_url) && (
        <div className="flex flex-col md:flex-row gap-6 mb-8 items-center md:flex-row-reverse">
          {partenaire.photo3_url && (
            <img
              src={partenaire.photo3_url}
              alt="photo 3"
              className="w-full md:w-1/2 rounded shadow"
            />
          )}
          {partenaire.description3 && (
            <div
              className="w-full md:w-1/2 prose dark:prose-invert max-w-none text-justify"
              dangerouslySetInnerHTML={{ __html: partenaire.description3 }}
            />
          )}
        </div>
      )}

      {/* Coordonnées */}
      <div className="text-sm text-gray-700 dark:text-gray-300 space-y-2 mb-8">
        {partenaire.adresse && (
          <p>
            <strong>Adresse :</strong> {partenaire.adresse}
          </p>
        )}
        {partenaire.tel && (
          <p>
            <strong>Téléphone :</strong> {partenaire.tel}
          </p>
        )}
        {partenaire.Mail && (
          <p>
            <strong>Email :</strong>{" "}
            <a
              href={`mailto:${partenaire.Mail}`}
              className="text-blue-600 underline"
            >
              {partenaire.Mail}
            </a>
          </p>
        )}
        {partenaire.link_url && (
          <p>
            <strong>Site :</strong>{" "}
            <a
              href={partenaire.link_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              {partenaire.link_url}
            </a>
          </p>
        )}
      </div>

      {/* Carte Google Maps */}
      {mapUrl && (
        <div className="w-full h-64 rounded overflow-hidden shadow mb-4">
          <iframe
            title="Google Maps"
            src={mapUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PartenaireDetail;
